import { Component, ElementRef, ViewContainerRef, Renderer2, Injector, ChangeDetectionStrategy, QueryList, ValueProvider, ContentChild } from '@angular/core';
import { ComponentBase, ComponentMixins, IComponentBase, applyMixins, PropertyCollectionInfo, setValue } from '@syncfusion/ej2-angular-base';
import { DropDownButton } from '@syncfusion/ej2-splitbuttons';

import { DropDownButtonItemsDirective } from './items.directive';

export const /** @type {?} */ inputs: string[] = ['content','cssClass','disabled','enableHtmlSanitizer','enablePersistence','enableRtl','iconCss','iconPosition','items','locale','target'];
export const /** @type {?} */ outputs: string[] = ['beforeClose','beforeItemRender','beforeOpen','close','created','open','select'];
export const /** @type {?} */ twoWays: string[] = [];
/**
 * Represents the Angular DropDownButton Component.
 * ```html
 * <button ejs-dropdownbutton>DropDownButton</button>
 * ```
 */
@ComponentMixins([ComponentBase])
export class DropDownButtonComponent extends DropDownButton implements IComponentBase {
public containerContext : any;
public tagObjects: any;
public childItems: QueryList<DropDownButtonItemsDirective>;
public tags: string[] = ['items'];
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.containerContext  = new ComponentBase();
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.containerContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.containerContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.containerContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        this.tagObjects[0].instance = this.childItems;
        this.containerContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: '[ejs-dropdownbutton]',
    inputs: inputs,
    outputs: outputs,
    template: `<ng-content ></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    queries: {
        childItems: new ContentChild(DropDownButtonItemsDirective)
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function DropDownButtonComponent_tsickle_Closure_declarations() {
/** @type {?} */
DropDownButtonComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownButtonComponent.ctorParameters;
/** @type {?} */
DropDownButtonComponent.prototype.containerContext;
/** @type {?} */
DropDownButtonComponent.prototype.tagObjects;
/** @type {?} */
DropDownButtonComponent.prototype.childItems;
/** @type {?} */
DropDownButtonComponent.prototype.tags;
/** @type {?} */
DropDownButtonComponent.prototype.registerEvents;
/** @type {?} */
DropDownButtonComponent.prototype.addTwoWay;
/** @type {?} */
DropDownButtonComponent.prototype.ngEle;
/** @type {?} */
DropDownButtonComponent.prototype.srenderer;
/** @type {?} */
DropDownButtonComponent.prototype.viewContainerRef;
/** @type {?} */
DropDownButtonComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
